<template>
  <b-form-group
    id="fieldset-1"
    :description="description"
    :label="label" label-cols="3" 
    label-for="inp" label-size="sm"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
  >
    <b-form-input :name="name" :type="type" id= "inp"
        :value="value" size="sm"
        @input.native="$emit('input',$event.target.value)"
        :placeholder="placeholder" :state="state" trim>
    </b-form-input>
  </b-form-group>
</template>
<script>
export default {
  name: 'TextInput',
  props: ['placeholder', 'label', 'name', 'value', 'description','type', 'invalidFeedback', 'validFeedback', 'state' ]
}
</script>